"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2026.08.10.)
 * RTL 2021 API (2026.08.10.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetDataFromJSON = WidgetDataFromJSON;
exports.WidgetDataFromJSONTyped = WidgetDataFromJSONTyped;
exports.WidgetDataToJSON = WidgetDataToJSON;
exports.WidgetDataToJSONTyped = WidgetDataToJSONTyped;
const runtime_1 = require("../runtime");
const _1 = require("./");
function WidgetDataFromJSON(json) {
    return WidgetDataFromJSONTyped(json, false);
}
function WidgetDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'componentName': !(0, runtime_1.exists)(json, 'componentName') ? undefined : json['componentName'],
        'parameters': !(0, runtime_1.exists)(json, 'parameters') ? undefined : (0, _1.WidgetDataParametersFromJSON)(json['parameters']),
    };
}
function WidgetDataToJSON(value) {
    return WidgetDataToJSONTyped(value, false);
}
function WidgetDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'componentName': value.componentName,
        'parameters': (0, _1.WidgetDataParametersToJSON)(value.parameters),
    };
}
